import styled, { css } from 'styled-components';

/* Section layout */
export const Section = styled.section`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;

  @media (max-width: 480px) {
    gap: 12px;
  }
`;

export const SectionHeader = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 12px;
`;

export const SectionTitle = styled.h3`
  position: relative;
  letter-spacing: 0.01em;
  line-height: 142.9%;
  font-weight: 600;
  margin: 0;
  font-size: 14px;
  color: rgba(46, 47, 51, 0.88);
`;

/* Banner content */
export const BannerContent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  position: relative;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

/* Drag handle */
export const DragHandle = styled.div`
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: grab;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  opacity: 0.5;

  &:hover {
    background-color: rgba(112, 115, 124, 0.1);
    opacity: 1;
  }

  &:active {
    cursor: grabbing;
  }

  @media (max-width: 768px) {
    left: -15px;
  }

  @media (max-width: 480px) {
    display: none;
  }
`;

export const BannerImage = styled.div`
  width: 336px;
  height: 116px;
  flex: 0 0 336px;

  /* Make the inner ImageUploadWrapper fill this container */
  & > * {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 200px;
  }
`;

export const BannerForm = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 16px;
  font-size: 16px;
  color: rgba(55, 56, 60, 0.28);
  width: 100%;
  min-width: 0;
`;

export const TitleRow = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const TitleInput = styled.div`
  flex: 1;
  min-width: 0;
  width: 100% !important;

  .input {
    width: 100% !important;
  }
`;

/* Color input wrapper */
export const ColorInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  padding: 8px 12px;
  background-color: white;
  width: 140px;
  min-width: 140px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ColorPicker = styled.input`
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background: none;
  outline: none;
  flex-shrink: 0;
`;

export const ColorTextInput = styled.input`
  border: none;
  outline: none;
  background: none;
  font-family: 'Pretendard JP', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #448181 !important;
  letter-spacing: 0.01em;
  width: 90px;
  text-transform: uppercase;

  &::placeholder {
    color: rgba(68, 129, 129, 0.5) !important;
  }
`;

export const CaptionRow = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const CaptionInput = styled.div`
  flex: 1;
  min-width: 0;
  width: 100% !important;

  .input {
    width: 100% !important;
  }
`;

/* Image upload */
export const ImageUploadWrapper = styled.div`
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  border: 1px solid rgba(112, 115, 124, 0.16);
  cursor: pointer;
  transition: border-color 0.2s ease;
  z-index: 10;

  &:hover {
    border-color: #448181;
  }
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  z-index: 11;
  pointer-events: auto;
`;

export const UploadIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  z-index: 12;
  pointer-events: none;
`;

export const UploadedImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  pointer-events: none;
`;

/* Input field */
export const InputFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  flex: 1;

  .input {
    width: 100% !important;
    border-radius: 12px;
    border: 1px solid rgba(112, 115, 124, 0.16);
    background-color: white;
    padding: 12px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: 'Pretendard JP', sans-serif;
    letter-spacing: 0.01em;
    line-height: 150%;
    color: rgba(55, 56, 60, 0.88);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
      outline: none;
      border-color: #448181;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.03), 0 0 0 3px rgba(68, 129, 129, 0.1);
    }

    &::placeholder {
      color: rgba(55, 56, 60, 0.28);
    }
  }
`;

/* Button */
export const StyledButton = styled.button<{ variant?: 'outlined' | 'primary' | 'text'; $disabled?: boolean }>`
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  cursor: pointer;
  font-family: 'Pretendard JP', sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 150%;
  transition: all 0.2s ease;
  border: none;
  background: none;
  position: relative;
  overflow: hidden;

  ${({ variant }) => variant === 'outlined' && css`
    border: 1px solid rgba(112, 115, 124, 0.16);
    color: rgba(46, 47, 51, 0.88);
    background-color: white;

    &:hover {
      border-color: #448181;
      color: #448181;
    }
  `}

  ${({ variant }) => variant === 'primary' && css`
    background-color: #448181;
    color: white;
    padding: 12px 28px;

    &:hover {
      background-color: #3a6f6f;
    }
  `}

  ${({ variant }) => variant === 'text' && css`
    color: rgba(55, 56, 60, 0.61);
    padding: 4px 16px;

    &:hover {
      background-color: rgba(112, 115, 124, 0.05);
    }
  `}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }

  ${({ $disabled }) => $disabled && css`
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  `}
`;

/* Action button (with disabled state) */
export const ActionButton = styled(StyledButton)<{ $isDisabled?: boolean }>`
  transition: all 0.2s ease;

  ${({ $isDisabled }) => $isDisabled && css`
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;

    &:hover {
      border-color: rgba(112, 115, 124, 0.16);
      color: rgba(46, 47, 51, 0.88);
    }
  `}
`;

/* Section actions */
export const SectionActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }
`;

export const SaveButton = styled(StyledButton)`
  width: 160px;

  @media (max-width: 480px) {
    width: 100%;
  }
`;

/* Loading / error messages */
export const LoadingMessage = styled.div`
  padding: 16px;
  text-align: center;
  color: rgba(68, 129, 129, 0.8);
  font-weight: 500;
  background-color: rgba(68, 129, 129, 0.05);
  border-radius: 8px;
  margin: 8px 0;
`;

export const ErrorMessage = styled.div`
  padding: 12px 16px;
  background-color: rgba(229, 34, 34, 0.05);
  border: 1px solid rgba(229, 34, 34, 0.2);
  border-radius: 8px;
  color: #e52222;
  font-weight: 500;
  font-size: 14px;
  margin: 8px 0;
`;

/* Lecture grid (used for mentor cards too) */
export const LectureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  margin-top: 16px;
  width: 100%;
`;

export const LectureCard = styled.div`
  position: relative;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: 12px;
  overflow: hidden;
  background-color: white;
  transition: all 0.2s ease;

  &:hover {
    border-color: #448181;
    box-shadow: 0 4px 12px rgba(68, 129, 129, 0.15);
  }

  &:hover button.remove-lecture-btn {
    opacity: 1;
  }
`;

export const LectureCardImage = styled.div`
  width: 100%;
  height: 140px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(112, 115, 124, 0.05);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const LectureCardContent = styled.div`
  padding: 12px;
`;

export const LectureTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #171719;
  margin: 0 0 4px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const LecturerName = styled.p`
  font-size: 12px;
  color: rgba(46, 47, 51, 0.6);
  margin: 0;
  line-height: 1.3;
`;

export const LectureTags = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 6px;
`;

export const Tag = styled.span`
  background-color: rgba(68, 129, 129, 0.1);
  color: #448181;
  font-size: 10px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1.2;
`;

export const RemoveLectureButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #448181;
  background-color: rgba(255, 255, 255, 0.9);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: 0;

  &:hover {
    background-color: #e52222;
    transform: scale(1.1);
  }
`;

export const AddLectureCard = styled.div<{ $disabled?: boolean }>`
  border: 2px dashed rgba(112, 115, 124, 0.3);
  border-radius: 12px;
  background-color: rgba(112, 115, 124, 0.02);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 200px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: rgba(112, 115, 124, 0.7);

  &:hover {
    border-color: #448181;
    background-color: rgba(68, 129, 129, 0.05);
    color: #448181;
  }

  span {
    font-size: 14px;
    font-weight: 500;
  }

  ${({ $disabled }) => $disabled && css`
    border-color: rgba(112, 115, 124, 0.2);
    background-color: rgba(112, 115, 124, 0.05);
    color: rgba(112, 115, 124, 0.5);
    cursor: not-allowed;
    opacity: 0.6;

    &:hover {
      border-color: rgba(112, 115, 124, 0.2);
      background-color: rgba(112, 115, 124, 0.05);
      color: rgba(112, 115, 124, 0.5);
      transform: none;
    }

    span {
      color: rgba(112, 115, 124, 0.5);
    }
  `}
`;

export const NoImage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: rgba(112, 115, 124, 0.6);
  background-color: rgba(112, 115, 124, 0.05);
`;

/* Lecture modal */
export const LectureModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
`;

export const ModalContent = styled.div`
  position: relative;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  max-width: 800px;
  max-height: 80vh;
  width: 90%;
  overflow: hidden;
  z-index: 1001;

  @media (max-width: 768px) {
    width: 95%;
    padding: 20px;
  }

  @media (max-width: 480px) {
    width: 98%;
    padding: 16px;
    margin: 8px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #171719;
  }

  button {
    width: 32px;
    height: 32px;
    border: none;
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: rgba(112, 115, 124, 0.7);
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: rgba(112, 115, 124, 0.1);
      color: #171719;
    }
  }
`;

export const ModalBody = styled.div`
  max-height: calc(80vh - 80px);
  overflow-y: auto;
  padding: 0;
`;

export const LectureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const LectureListItem = styled.div<{ $alreadyAdded?: boolean }>`
  display: flex;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.08);
  cursor: pointer;
  transition: background-color 0.2s ease;
  position: relative;

  &:hover {
    background-color: rgba(68, 129, 129, 0.05);
  }

  &:last-child {
    border-bottom: none;
  }

  ${({ $alreadyAdded }) => $alreadyAdded && css`
    opacity: 0.6;
    background-color: #f8f9fa;
    border-left: 4px solid #28a745;
    cursor: not-allowed;

    &:hover {
      background-color: #f8f9fa;
      transform: none;
    }
  `}
`;

export const LectureListImage = styled.div`
  width: 80px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: rgba(112, 115, 124, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const LectureListContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;

  h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #171719;
    line-height: 1.4;
  }

  p {
    margin: 0;
    font-size: 12px;
    color: rgba(46, 47, 51, 0.6);
    line-height: 1.3;
  }
`;

export const AddedIndicator = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: #28a745;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: bold;
  z-index: 1;
`;

/* Curation content */
export const CurationContent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 16px;
`;

export const CurationForm = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const FormGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
`;

export const DescriptionInput = styled.div`
  flex: 1;
  font-size: 16px;
`;

export const CurationButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const SaveIndividualButton = styled(StyledButton)`
  margin-right: 8px;
  min-width: 120px;
  font-size: 14px;
  padding: 10px 16px;
`;
